"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _clsx = _interopRequireDefault(require("clsx"));
var _isArray = _interopRequireDefault(require("lodash/isArray"));
var _Label = _interopRequireDefault(require("./Label.styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Typography = (0, _component.default)(() => import("@micado-digital/react-ui/components/Typography"));
const Label = _ref => {
  let {
    label,
    showSelectedValues,
    values
  } = _ref;
  const css = (0, _Label.default)();
  const selectedValues = (0, _react.useMemo)(() => {
    if (!(0, _isArray.default)(values)) return values;
    let tmpValues = [];
    tmpValues = values?.filter(option => option?.selected)?.map(option => {
      return option?.title;
    });
    return tmpValues?.join(", ");
  }, [values]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(Typography, {
    className: (0, _clsx.default)(css.label, "mco-filter-item__label"),
    variant: "label-medium"
  }, label), showSelectedValues && !!values && /*#__PURE__*/_react.default.createElement(Typography, {
    className: (0, _clsx.default)(css.selectedLabel, "mco-filter-item__label-selected"),
    variant: "body-small"
  }, selectedValues));
};
var _default = exports.default = Label;